<template>
	<div>
		<div v-if="loading" class="dynvibeLoading"></div>
		<div v-if="!loading && noData" class="noData">
			<p>No Data to display</p>
		</div>
		<highcharts v-if="!loading && !noData" class="highcharts-container" ref="chartComponent" :options="chartOptions"></highcharts>
	</div>
</template>

<script>
export default {
	name: "DynamicChart",
	data() {
		return {
			loading: true,
			noData: false,
			allseries: {},
			countries: [
				["FR", "France"],
				["US", "USA"],
				["UK", "United Kingdom"],
				["ES", "Spain"],
			],
			date: {
				gte: "",
				lte: "",
			},
			data: {},
			front: false,
		};
	},
	mounted: function () {
		this.date = this.$store.getters.parameters.date;
		this.getData("getStats", {
			type: "all",
			level: "mastertag",
			filters: {
				date: this.date,
			},
		});
	},
	computed: {
		chartOptions: function () {
			return {
				chart: {
					type: "bubble",
					plotBorderWidth: 1,
					zoomType: "xy",
					marginTop: 50,
					marginBottom: 50,
					marginLeft: 70,
					marginRight: 50,
				},
				colors: ["#03BAB8", "#21F305", "#E30404", "#FFB500", "#AEE", "#F06"],
				legend: { enabled: this.front },
				title: { text: "" },
				xAxis: {
					title: {
						enabled: true,
						text: "Period Dynamic",
					},
					plotLines: [
						{
							color: "#000000",
							width: 2,
							value: 0,
						},
					],
				},
				yAxis: {
					title: {
						text: "Average Dynamic",
					},
					plotLines: [
						{
							color: "#000000",
							width: 2,
							value: 0,
						},
					],
				},
				plotOptions: {
					series: {
						dataLabels: {
							enabled: false,
							format: "{point.topic}",
						},
						states: {
							inactive: {
								opacity: 1,
							},
						},
						point: {
							events: {
								mouseOver: function () {
									let thisSeries = this.series,
										allSeries = thisSeries.chart.series;

									allSeries.forEach((s) => {
										s.points.forEach((point) => {
											if (!point.topic.includes(this.topic)) {
												point.update(
													{
														color: thisSeries.chart.options.colors[point.colorIndex] + "11",
													},
													false
												);
											}
										});
									});
									thisSeries.chart.redraw();
								},
								mouseOut: function () {
									let thisSeries = this.series,
										allSeries = thisSeries.chart.series;

									allSeries.forEach((s) => {
										s.points.forEach((point) => {
											point.update(
												{
													color: thisSeries.chart.options.colors[point.colorIndex],
												},
												false
											);
										});
									});
									thisSeries.chart.redraw();
								},
								click: (e) => {
									this.allseries.data.sort((a, b) => {
										return b.x - a.x;
									});
									this.$emit("clicked", {
										topic: e.point.topic,
										periodGrowth: e.point.category,
										rank: this.allseries.data.map((e) => e.topic).indexOf(e.point.topic),
									});
								},
							},
						},
					},
				},
				tooltip: {
					hideDelay: 100,
					useHTML: true,
					headerFormat: "<div>",
					pointFormat:
						"<h4>{point.topic}</h4>" +
						"<p>Period Dynamic:{point.x}%<br>" +
						"Average Dynamic: {point.y} %<br>" +
						"Total Volume: {point.z} posts</p>",
					footerFormat: "</div>",
					followPointer: true,
				},
				series: this.allseries,
			};
		},
	},
	methods: {
		checkFilters() {
			if (this.date.gte === "" || this.date.length === 0) {
				return;
			}
			this.hidden = false;
			this.loading = true;

			this.getData("getStats", {
				type: this.type,
				level: "mastertag",
				filters: {
					panel: this.panel,
					segment: this.segment,
					date: this.date,
					country: this.country,
				},
			});
		},
		treatResponse(response) {
			this.loading = false;
			this.data = response.data;
			this.noData = this.data.length === 0 ? true : false;
			this.allseries = {
				data: [],
			};
			let minX = Math.ceil(-120);
			let maxX = Math.floor(120);
			let minY = Math.ceil(-100);
			let maxY = Math.floor(100);
			let minZ = Math.ceil(0);
			let maxZ = Math.floor(10000);

			let topics = [];
			let avgs = [];
			for (let i in this.data) {
				topics.push(this.data[i].key);
			}
			if (this.front == false && topics.length > 0 && this.date.gte != "") {
				this.$axios
					.post(this.$backendUrl + "avgGrowths", this.$Qs.stringify({ topics: topics, date: this.date }))
					.then((response) => {
						avgs = response.data;

						this.$axios
							.post(
								this.$backendUrl + "globalCount",
								this.$Qs.stringify({
									type: "mastertag",
									data: topics,
								})
							)
							.then((response) => {
								loop1: for (let j in topics) {
									if (this.data[j].date_range != undefined && response.data[topics[j]] != undefined) {
										let startValue =
											this.data[j].date_range.buckets[0].doc_count == 0
												? 1
												: this.data[j].date_range.buckets[0].doc_count;
										let endValue = this.data[j].date_range.buckets[1].doc_count;
										let x = Math.round(((endValue - startValue) / startValue) * 100);
										if (x < 0) {
											x *= 100;
										}
										let y = Math.round(avgs[j].avg);
										let z = response.data[topics[j]];

										// filter some data
										if (x >= 0 && x < 100 && y < 100) {
											continue loop1;
										} else if (x <= 0 && x > -25 && y < 100) {
											continue loop1;
										} else if (y == 0) {
											continue loop1;
										}

										this.allseries["data"].push({
											x: x,
											y: y,
											z: z,
											topic: topics[j],
										});
									}
								}
							});
					});
			} else {
				for (let i in this.countries) {
					let country = this.countries[i][1];

					this.allseries[i] = {
						country: country,
						name: country,
						data: [],
					};

					for (let j in topics) {
						this.allseries[i]["data"].push({
							x: Math.floor(Math.random() * (maxX - minX)) + minX,
							y: Math.floor(Math.random() * (maxY - minY)) + minY,
							z: Math.floor(Math.random() * (maxZ - minZ)) + minZ,
							topic: topics[j],
						});
					}
				}
			}
		},
	},
	watch: {
		panel() {
			this.checkFilters();
		},
		segment() {
			this.checkFilters();
		},
		date: {
			deep: true,
			handler() {
				this.checkFilters();
			},
		},
		country() {
			this.checkFilters();
		},
		category() {
			this.checkFilters();
		},
		subcategory() {
			this.checkFilters();
		},
		mastertag() {
			this.checkFilters();
		},
		"$store.state.parameters": function () {
			this.date = this.$store.getters.parameters.date;
		},
	},
};
</script>

<style scoped>
.highcharts-container {
	overflow: visible !important;
}
</style>
